exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".title {\n  margin-top: 10px !important; }\n\n.main-container {\n  margin-top: 18px;\n  display: flex; }\n  .main-container .left-panel {\n    width: 210px;\n    min-width: 210px; }\n    .main-container .left-panel .palet-container {\n      border: 1px solid grey;\n      border-radius: 3px;\n      padding: 4px;\n      overflow: auto; }\n      .main-container .left-panel .palet-container .form-elem {\n        border: 1px solid grey; }\n  .main-container .center-panel {\n    width: 80%;\n    padding-left: 4px;\n    padding-right: 4px; }\n  .main-container .right-panel {\n    width: 254px;\n    min-width: 254px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 437
// module chunks = 0